import ToolTipView from 'views/utils/ToolTipView';

export default {
    renderTooltips: function() {
        var that = this;
        this.tooltipCollection = [];

        this.$('.has-tooltip').each(function() {
            that.tooltipCollection.push(
                new ToolTipView({
                    el: $(this)
                })
            );
        });
    },

    hideTooltips: function() {
        if (this.tooltipCollection) {
            for (var i = 0, len = this.tooltipCollection.length; i < len; i += 1) {
                if (this.tooltipCollection[i] && typeof this.tooltipCollection[i].hide === 'function') {
                    this.tooltipCollection[i].hide();
                }
            }
        }
    }
};
